"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlesContent = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const next_components_shared_article_1 = __importDefault(require("@motorata/next.components.shared.article"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_molecules_pagination_1 = require("@motorata/base-ui.components.molecules.pagination");
const ArticlesContent = (_a) => {
    var { title = "Ostatnie artykuły", label = "Blog", articles = [], currentPage, totalPages, onChangePage } = _a, rest = __rest(_a, ["title", "label", "articles", "currentPage", "totalPages", "onChangePage"]);
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest),
        react_1.default.createElement(base_ui_components_atoms_typography_1.Title, { label: label }, title),
        react_1.default.createElement(Content, null, articles.map(article => (react_1.default.createElement(next_components_shared_article_1.default, { key: article.id, slug: article.slug, title: article.title, image: article.images.medium, lead: article.blockLead, date: article.date, readingTime: article.readingTime })))),
        react_1.default.createElement(base_ui_components_molecules_pagination_1.Pagination, { defaultPage: currentPage, totalPages: totalPages, onChange: onChangePage })));
};
exports.ArticlesContent = ArticlesContent;
const Content = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 2rem;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;
const Wrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  ${base_ui_components_atoms__atoms_1.blockStyles};
  ${base_ui_components_atoms__atoms_1.common};
`;
//# sourceMappingURL=ArticlesContent.js.map